/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Text_To_Audio_Title_PlaceholderInputs */

const en_dialog_text_to_audio_title_placeholder = /** @type {(inputs: Dialog_Text_To_Audio_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untitled document`)
};

const es_dialog_text_to_audio_title_placeholder = /** @type {(inputs: Dialog_Text_To_Audio_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documento sin título`)
};

/**
* | output |
* | --- |
* | "Untitled document" |
*
* @param {Dialog_Text_To_Audio_Title_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_text_to_audio_title_placeholder = /** @type {((inputs?: Dialog_Text_To_Audio_Title_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Text_To_Audio_Title_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_text_to_audio_title_placeholder(inputs)
	return en_dialog_text_to_audio_title_placeholder(inputs)
});